<div class="typing-indicator" role="status" aria-label="Assistant is responding" data-testid="typing-indicator-container">
	<span class="ai-label">AI</span>
	<div class="indicator-content">
		<span class="cursor-bar"></span>
		<span class="status-text">{{ statusText }}</span>
	</div>
</div>
